import type { FaireProductEntity } from "../../entity_types/product";

export const p_733ffqa86b: FaireProductEntity = {
  token: "p_733ffqa86b",
  type: "product",
  name: "The Táche Hat",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl: "https://cdn.faire.com/fastly/2259270082ffdb9f6976555f409d03f92db283d3daadc4ad9d255d9f041b70ec.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02510d401906e44cb27c4fd75738c094a4ee8f93b574e98b3088c8467dff1f9a.png",
    "https://cdn.faire.com/fastly/8d791d6637069b79c09e3c07cee6036441cc0189f9ae0b83f8fa91e92e8329d4.png"
  ],
  priceDollars: 35,
  description: "For sun, shade, bad hair days, great style moments, and general distant acquaintance avoidance. The Táche hat in stone khaki goes with everything and features a subtle blind embroidered logo for gatekeeping your favorite alt milk. Plus, it has an adjustable band for customizable comfort.",
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:38.679Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
